import React from 'react';
import { commonPropTypes, commonDefaultPropTypes } from '../popedit/PropTypes';
import Popedit from '../popedit/Popedit';
import Panel from './Panel';


class Select extends React.Component {
  /** *******************static************************** */

  static propTypes = Object.assign(commonPropTypes);

  static defaultProps = Object.assign(commonDefaultPropTypes);

  render() {
    const { api, showSearch, searchPlaceholder } = this.props;
    const panelProps = { api, showSearch, searchPlaceholder };
    return (
      <Popedit
        {...this.props}
        inputClassName="mk-enhanced-tree-select-input"
      >
        <Panel {...panelProps} />
      </Popedit>

    );
  }
}

export default Select;
